var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qrcode-wrap" }, [
    _c("div", { staticClass: "qrcode-title" }, [_vm._v("扫码登录")]),
    _c("div", { staticClass: "qrcode-img" }, [
      _c("img", { attrs: { src: _vm.qrcodeImgUrl } }),
      _vm.isQrcodeAlert
        ? _c(
            "div",
            { staticClass: "invalid" },
            [
              _c("div", [_vm._v(_vm._s(_vm.qrcodeAlertMessage))]),
              _c(
                "sw-button",
                {
                  attrs: { size: "small", type: "primary", round: "" },
                  on: { click: _vm.refreshQrCode }
                },
                [_vm._v("刷新二维码")]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "qrcode-text" }, [
      _vm._v(
        "请使用" +
          _vm._s(_vm.config.scanClientInfo || "超级APP") +
          "“扫一扫”功能扫描二维码登录"
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }